// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__v-iBk","colMin":"styles_colMin__G2IrC"};